import React, { ReactElement, useState } from 'react'
import { IFeedback } from '.'
//MUI
import Grid from '@mui/material/Grid'
import SvgIcon from '@mui/material/SvgIcon'
import Typography from '@mui/material/Typography'
//Assets
import SuccessIcon from '@tdcerhverv/parrotfish/dist/icons/Icons/Success_filled.svg'
import ErrorIcon from '@tdcerhverv/parrotfish/dist/icons/Icons/Error_filled.svg'
import Close from '@tdcerhverv/parrotfish/dist/icons/Icons/Close.svg'
import Button from '@mui/material/Button'
import RichText, { IRichText } from '../RichText'
import Image, { IImage } from '../Image'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material'
import CallToAction from '../CallToAction'
import { ContentfulToComponent, ContentfulToComponentProps } from '../RichText/types'

const styles = {
  root: { margin: '100px 0' },
  feedbackTitle: { padding: '16px 0 16px 0', justifyContent: 'center', color: 'success.main' },
  cta: { marginBottom: '20px' },
  imageStyle: {
    height: '150px',
  },
  content: { textAlign: 'center' },
  dialog: { width: '350px' },
  successIcon: { fontSize: '40px', color: 'success.main' },
  failureIcon: { fontSize: '40px', color: 'error.dark' },
  errorColor: { color: 'error.dark' },
  successColor: { color: 'success.main' },
  button: {
    m: '24px auto 0 !important',
  },
}
export const UnwrappedFeedback = ({
  buttonLabel,
  onClick,
  body,
  icon,
  title,
  isError,
  errorMessage,
  successMessage,
}: IFeedback) => {
  const feedbackMessage = isError ? errorMessage : successMessage
  const propsMap: Partial<ContentfulToComponentProps> = {
    ContentfulComponentCta: <CallToActionType,>(props: CallToActionType) => ({
      ...(props as unknown as CallToActionType),
    }),
  } as const

  const feebackComponentMap: Partial<ContentfulToComponent> = {
    'ContentfulComponentCta': CallToAction,
  } as const
  return (
    <div style={{ textAlign: 'center' }}>
      {icon ? (
        <Image {...(icon as IImage)} imageStyles={styles.imageStyle} />
      ) : (
        <SvgIcon
          sx={!isError ? styles.successIcon : styles.failureIcon}
          component={!isError ? SuccessIcon : ErrorIcon}
          viewBox={'0 0 48 48'}
        />
      )}
      <Typography variant="subtitle1" sx={{ ...styles.feedbackTitle }}>
        {title}
      </Typography>
      <RichText
        {...(body as IRichText)}
        componentMap={feebackComponentMap as ContentfulToComponent}
        propsMap={propsMap as ContentfulToComponentProps}
      />
      {buttonLabel && (
        <Button sx={styles.button} variant={!isError ? 'outlined' : 'contained'} onClick={onClick}>
          {buttonLabel}
        </Button>
      )}
    </div>
  )
}

export const Feedback = (feedbackProps: IFeedback): React.ReactNode => {
  const propsMap: Partial<ContentfulToComponentProps> = {
    ContentfulComponentCta: <CallToActionType,>(props: CallToActionType) => ({
      ...(props as unknown as CallToActionType),
    }),
  } as const

  const feebackComponentMap: Partial<ContentfulToComponent> = {
    'ContentfulComponentCta': CallToAction,
  } as const
  const { isError, errorMessage, successMessage } = feedbackProps
  const [isPopupVisible, setPopupVisible] = useState(true)
  const [isFeedbackClosed, setFeedbackClosed] = useState(false)

  const handleClosePopup = () => {
    setPopupVisible(false)
    setFeedbackClosed(true)
  }

  if (feedbackProps?.showPopupOnPage && isPopupVisible) {
    return (
      <Dialog open={isPopupVisible} PaperProps={{ sx: styles.dialog }}>
        <DialogTitle>
          <IconButton onClick={handleClosePopup}>
            <SvgIcon component={Close} fontSize="inherit" viewBox={'0 0 48 48'} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={styles.content}>
          {feedbackProps?.icon ? (
            <Image {...(feedbackProps?.icon as IImage)} imageStyles={styles.imageStyle} />
          ) : (
            <SvgIcon
              sx={!isError ? styles.successIcon : styles.failureIcon}
              component={!isError ? SuccessIcon : ErrorIcon}
              viewBox={'0 0 48 48'}
            />
          )}
          <Typography variant="subtitle1" sx={{ ...styles.feedbackTitle }}>
            {feedbackProps.title}
          </Typography>
          <RichText
            {...(feedbackProps.body as IRichText)}
            componentMap={feebackComponentMap as ContentfulToComponent}
            propsMap={propsMap as ContentfulToComponentProps}
          />
          {feedbackProps.buttonLabel && (
            <Button sx={styles.button} variant={!isError ? 'outlined' : 'contained'} onClick={feedbackProps.onClick}>
              {feedbackProps.buttonLabel}
            </Button>
          )}
        </DialogContent>
      </Dialog>
    )
  }

  if (isFeedbackClosed) {
    return null
  }

  return (
    <Grid container sx={styles.root} justifyContent="center">
      <div>
        <UnwrappedFeedback {...feedbackProps} />
      </div>
    </Grid>
  )
}
